import fromPairs from 'lodash/fromPairs';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import toPairs from 'lodash/toPairs';

import { COMMUNITY_INTERACTION_TYPES } from '@/app/community/constants';

export const sortMessages = (messages) => {
  if (messages.length === 0) {
    return messages;
  }
  const { type } = messages[0];
  let createdAtField;
  if (type === COMMUNITY_INTERACTION_TYPES.FACEBOOK_CONVERSATION) {
    createdAtField = 'facebookCreatedAt';
  } else if (type === COMMUNITY_INTERACTION_TYPES.TWITTER_CONVERSATION) {
    createdAtField = 'twitterCreatedAt';
  } else {
    createdAtField = 'instagramCreatedAt';
  }

  const sortedByCreatedAt = sortBy(messages, [
    (message) => message[createdAtField].valueOf(),
    (message) => message.id,
  ]);
  const sentMessages = sortedByCreatedAt.filter((m) => !m.isPending);
  const pendingMessages = sortedByCreatedAt.filter((m) => m.isPending);
  const messageList = [...sentMessages, ...pendingMessages];

  return messageList;
};

const reactionsToMap = (reactions) =>
  fromPairs(
    (reactions || []).flatMap(({ type, participantIds }) =>
      participantIds.map((pid) => [pid, type]),
    ),
  );

const reactionsToList = (reactionsMap) => {
  const reactions = toPairs(groupBy(toPairs(reactionsMap), (pair) => pair[1]))
    .map(([type, items]) => ({
      type,
      participantIds: items.map((item) => parseInt(item[0], 10)),
    }))
    .filter(({ participantIds, type }) => type && participantIds.length > 0);
  return reactions.length === 0 ? null : reactions;
};

// DM_REFACTOR_2026: dict-based reactions for message interactions
export const setMessageReaction = (message, reactionType, participantId, add) => {
  if (!participantId || !reactionType) return message;
  const reactions = { ...(message.reactions || {}) };
  const existing = reactions[reactionType] || { participantIds: [], code: null };

  if (add) {
    if (!existing.participantIds.includes(participantId)) {
      reactions[reactionType] = {
        ...existing,
        participantIds: [...existing.participantIds, participantId],
      };
    }
  } else {
    const filtered = existing.participantIds.filter((id) => id !== participantId);
    if (filtered.length === 0) {
      delete reactions[reactionType];
    } else {
      reactions[reactionType] = { ...existing, participantIds: filtered };
    }
  }
  return { ...message, reactions: Object.keys(reactions).length === 0 ? null : reactions };
};

// Deprecated
export const setReaction = (message, reaction, participantId) => {
  const reactionsMap = reactionsToMap(message.reactions);
  if (reaction) {
    reactionsMap[participantId] = reaction;
  } else {
    delete reactionsMap[participantId];
  }
  return {
    ...message,
    reactions: reactionsToList(reactionsMap),
  };
};
